import styled from 'styled-components';

export default styled.a`
  text-decoration: none;
  font-weight: normal;
  color: ${props => props.theme.enigmaBlue};
  text-transform: none;
  &:hover,
  &:focus,
  &:active,
  &:visited {
    text-decoration: none;
  }

  &:hover {
    cursor: pointer;
    color: ${props => props.theme.enigmaBlue};
  }
`;
